import { get } from 'lodash';
import httpStatus from 'http-status-codes';

import ClientsClass from '../../clients/ClientsClass';
import { ILeadSource, ILoanAccount } from '../../interfaces';

// What the Account Info form hands back for the referral source: a source picked from the search,
// the category and name typed for a new one, or null to clear it.
type ILeadSourcePick = ILeadSource | Pick<ILeadSource, 'category' | 'name'> | null;

export type ILoanAccountFormData = Partial<Omit<ILoanAccount, 'lead_source'>> & { lead_source?: ILeadSourcePick };
type ILoanAccountRequestData = Partial<Omit<ILoanAccount, 'lead_source'>> & { lead_source?: null | string };

// /loan-accounts/ takes a lead source by id, so one typed into the form is created first, as
// CaseStore.applyLeadSource does for a case.
export async function withLeadSourceId (Clients: ClientsClass, data: ILoanAccountFormData): Promise<ILoanAccountRequestData> {
  const { lead_source, ...account } = data;

  if (lead_source === undefined) { return account; }
  if (lead_source === null) { return { ...account, lead_source: null }; }

  const leadSource = 'id' in lead_source ? lead_source : await createLeadSource(Clients, lead_source);

  return { ...account, lead_source: leadSource.id };
}

async function createLeadSource (Clients: ClientsClass, leadSource: Pick<ILeadSource, 'category' | 'name'>): Promise<ILeadSource> {
  try {
    return await Clients.leadSources.create(leadSource);
  }
  catch (err) {
    // FormManager maps a 400 onto the account form's fields by name, where a rejected source name
    // would land on the account's own. Keyed under the field it lands on the nested name input.
    if (get(err, 'response.status') === httpStatus.BAD_REQUEST) {
      err.response.data = { lead_source: err.response.data };
    }
    throw err;
  }
}
